import React from 'react';
import { connect } from 'react-redux';
import { getCMSObject, TeleScript } from 'sg-ui-components';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle.js';

import { getForgotPasswordLink, getAccountLink, getSSOLink } from '../utils/getLinks';

const FaqsPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: 'FAQs',
        className: 'faqs',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title={page?.title} />
            </div>
            <div className='static-content'>
                <TeleScript
                    line={getCMSObject('data.microsite.general.faqs.contentHTML')}
                    replace={{
                        '%PROMOTION_URL%': config?.config?.appUrl ?? '/',
                        '%PLAYERS_CLUB_URL%': user?.loggedIn ? getSSOLink(config) : getAccountLink(config),
                        '%FORGOT_PASSWORD_URL%': getForgotPasswordLink(config) ?? '/',
                    }}
                />
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(FaqsPage);
